import { render, staticRenderFns } from "./MonitoringTargetDetailDetail.vue?vue&type=template&id=1a245f2a"
import script from "./MonitoringTargetDetailDetail.vue?vue&type=script&lang=ts"
export * from "./MonitoringTargetDetailDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports